import { createContext, useContext, useState, useEffect, useRef } from "react";
import { userServices } from "../APIServices/UserData/userServices";
import { plateformSettingServices } from "../APIServices/GlobalManagements/plateformSettingServices";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  let auth = localStorage.getItem("token");
  const [currentUserData, setCurrentUserData] = useState(null);
  const [plateformSettings, setPlateformSettings] = useState(null);
  const [apiUpdator, setAPIUpdator] = useState("");

  const getCurrectLoginUser = async () => {
    const data = await userServices.getCurrectLoginUser();
    setCurrentUserData(data?.data || null);
  };

  const getSinglePlateformSettings = async () => {
    const data = await plateformSettingServices.getSinglePlateformSettings();
    setPlateformSettings(data?.data || null);
  };

  useEffect(() => {
    if (auth) {
      getSinglePlateformSettings();
      getCurrectLoginUser();
    }
  }, []);

  return (
    <AppContext.Provider
      value={{
        // User
        currentUserData,
        setCurrentUserData,
        getCurrectLoginUser,

        // Platform / Theme
        plateformSettings,
        setPlateformSettings,
        getSinglePlateformSettings,

        // Vault
        setAPIUpdator,
        apiUpdator,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
